import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";

export default class UpdateAppMediumRequest {
    name: string = '';
    state: AppMediumState;
    accessTokenLifetime: number = 0;
    refreshTokenLifetime: number = 0;
    whitelist: string[] = [];
}